import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useOnPressAwardDeeplink = () => {
  return useCallback<(deeplink: string) => void>(deeplink => {
    bridge.openDeeplink(deeplink);
  }, []);
};
